import { createStoreCollections as L, extendedCollectionDataFactory as R } from "./collections.js";
import { createStoreCookies as ee } from "./cookies.js";
import { createStoreEnvironments as te, extendedEnvironmentDataFactory as re } from "./environment.js";
import { createStoreEvents as oe } from "./events.js";
import { importSpecFileFactory as se } from "./import-spec.js";
import { createStoreRequestExamples as de, extendedExampleDataFactory as ae } from "./request-example.js";
import { createStoreRequests as ne, extendedRequestDataFactory as ce } from "./requests.js";
import { createStoreSecuritySchemes as ie, extendedSecurityDataFactory as me } from "./security-schemes.js";
import { createStoreServers as le, extendedServerDataFactory as pe } from "./servers.js";
import { createStoreTags as ue, extendedTagDataFactory as ve } from "./tags.js";
import { createStoreWorkspaces as Se, extendedWorkspaceDataFactory as fe } from "./workspace.js";
import { useModal as Ee } from "@scalar/components";
import { inject as Me, reactive as xe, ref as ye, toRaw as r } from "vue";
const Pe = ({
  useLocalStorage: e = !0,
  showSidebar: C = !0,
  proxyUrl: a,
  theme: E,
  hideClientButton: A = !1,
  _integration: D
}) => {
  const { collections: n, collectionMutators: c } = L(e), { tags: i, tagMutators: m } = ue(e), { requests: l, requestMutators: p } = ne(e), { requestExamples: u, requestExampleMutators: v } = de(e), { cookies: M, cookieMutators: b } = ee(e), { environments: x, environmentMutators: y } = te(e), { servers: q, serverMutators: S } = le(e), { securitySchemes: w, securitySchemeMutators: f } = ie(e), { workspaces: d, workspaceMutators: o } = Se(e), t = {
    collections: n,
    collectionMutators: c,
    tags: i,
    tagMutators: m,
    requests: l,
    requestMutators: p,
    requestExamples: u,
    requestExampleMutators: v,
    environmentMutators: y,
    serverMutators: S,
    securitySchemeMutators: f,
    workspaces: d,
    workspaceMutators: o
  }, { addTag: k, deleteTag: O } = ve(t), { addRequest: T, deleteRequest: I, findRequestParents: P } = ce(t, k), { deleteEnvironment: g } = re(t), { addServer: j, deleteServer: B } = pe(t), { addCollection: K, deleteCollection: Y } = R(t), { addRequestExample: _, deleteRequestExample: H } = ae(t), { addWorkspace: z, deleteWorkspace: G } = fe(t), { addSecurityScheme: J, deleteSecurityScheme: N } = me(t), { addCollectionEnvironment: W, removeCollectionEnvironment: h } = R(t), Q = xe([]), { importSpecFile: U, importSpecFromUrl: V } = se(t), F = ye((e ? localStorage == null ? void 0 : localStorage.getItem("sidebarWidth") : void 0) || "280px"), X = (s) => {
    F.value = s, e && (localStorage == null || localStorage.setItem("sidebarWidth", s));
  }, Z = Ee();
  Object.values(d).forEach(({ uid: s }) => {
    a && o.edit(s, "proxyUrl", a), E && o.edit(s, "themeId", E);
  }), typeof window < "u" && (window.dataDump = () => ({
    collections: r(n),
    cookies: r(M),
    environments: r(x),
    requestExamples: r(u),
    requests: r(l),
    securitySchemes: r(w),
    servers: r(q),
    tags: r(i),
    workspaces: r(d)
  }));
  const $ = oe();
  return {
    // ---------------------------------------------------------------------------
    // STATE
    workspaces: d,
    collections: n,
    tags: i,
    cookies: M,
    environments: x,
    requestExamples: u,
    requests: l,
    servers: q,
    securitySchemes: w,
    modalState: Z,
    events: $,
    sidebarWidth: F,
    setSidebarWidth: X,
    proxyUrl: a,
    // ---------------------------------------------------------------------------
    // CONFIGURATION "PROPS"
    // TODO: move these to their own store
    hideClientButton: A,
    showSidebar: C,
    integration: D,
    // ---------------------------------------------------------------------------
    // METHODS
    importSpecFile: U,
    importSpecFromUrl: V,
    cookieMutators: b,
    collectionMutators: {
      ...c,
      rawAdd: c.add,
      add: K,
      delete: Y,
      addEnvironment: W,
      removeEnvironment: h
    },
    environmentMutators: {
      ...y,
      delete: g
    },
    requestMutators: {
      ...p,
      rawAdd: p.add,
      add: T,
      delete: I
    },
    findRequestParents: P,
    requestExampleMutators: {
      ...v,
      rawAdd: v.add,
      add: _,
      delete: H
    },
    requestHistory: Q,
    securitySchemeMutators: {
      ...f,
      rawAdd: f.add,
      add: J,
      delete: N
    },
    serverMutators: {
      ...S,
      rawAdd: S.add,
      add: j,
      delete: B
    },
    tagMutators: {
      ...m,
      rawAdd: m.add,
      add: k,
      delete: O
    },
    workspaceMutators: {
      ...o,
      rawAdd: o.add,
      add: z,
      delete: G
    },
    addCollectionEnvironment: W,
    removeCollectionEnvironment: h
  };
}, qe = "WORKSPACE_SYMBOL", ge = () => {
  const e = Me(qe);
  if (!e)
    throw new Error("Workspace store not provided");
  return e;
};
export {
  qe as WORKSPACE_SYMBOL,
  Pe as createWorkspaceStore,
  ge as useWorkspace
};
